<div class="categories">
  @for (category of categories; track category) {
    <div class="category">
      <h4>{{ 'productSuggestions.category.' + category | translate }}</h4>
      <table mat-table [dataSource]="forCategory(category)" class="suggestions-table">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let suggestion">
            <mat-checkbox
              [checked]="isSelected(suggestion)"
              (change)="updateSelection($event.checked, suggestion)"
            ></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="product">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'productSuggestions.column.product' | translate }}
          </th>
          <td mat-cell *matCellDef="let suggestion">{{ suggestion.product }}</td>
        </ng-container>

        <ng-container matColumnDef="organisation">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'productSuggestions.column.organisation' | translate }}
          </th>
          <td mat-cell *matCellDef="let suggestion">{{ suggestion.organisation }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns"></tr>
      </table>
    </div>
  }
</div>
